import getMarkdocModel from "../../getters/markdocModel";

export const tsDiagram = getMarkdocModel("Ts-diagram");
